export enum ApprovalStatus {
  Pending = 0,
  Approved = 1,
}
